import { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../../../store'
import { forgotPassword } from '../../../store/auth/authSlice'
import CheckEmailForm from '../../forms/CheckEmailForm'
import ForgotPasswordForm from '../../forms/ForgotPasswordForm'
import { useForm } from 'react-hook-form'
import { vestResolver } from '@hookform/resolvers/vest'
import { IForgotPasswordFormValues } from '../../forms/ForgotPasswordForm/types'
import { formValidation } from './utils'

import { success } from '../../../utils/alertUtils';

const defaultValues = { email: '' }

export interface IWizzard {
  [key: number]: any
}

const ForgotPasswordWizzard: React.FC = () => {
  const [currentStep, setCurrentStep] = useState<number>(1)

  const dispatch = useDispatch<AppDispatch>()

  const onSubmit = (data: IForgotPasswordFormValues) => {
    if (currentStep === 1) {
      dispatch(forgotPassword(data as { email: string }))
      setCurrentStep(2)
      return
    }
    dispatch(forgotPassword(data as { email: string }))
    success('Successfully sent!')
  }

  // #region form flow

  const formMethods = useForm<IForgotPasswordFormValues>({
    defaultValues,
    resolver: vestResolver(formValidation),
    mode: 'onChange',
    shouldFocusError: false,
  })

  const { register, handleSubmit, formState, getValues } = formMethods

  const getMessage = useCallback(
    (field: 'email') => {
      if (!formState.errors[field]) return ''

      return formState.errors[field]!.message
    },
    [formState],
  )

  // #endregion

  const wizzardSteps: IWizzard = {
    1: <ForgotPasswordForm emailError={getMessage('email')} register={register} />,
    2: <CheckEmailForm email={getValues('email')} onSubmit={handleSubmit(onSubmit)} />,
  }

  const resolveStep = () => {
    return wizzardSteps[currentStep]
  }

  return <form onSubmit={handleSubmit(onSubmit)}>{resolveStep()}</form>
}

export default ForgotPasswordWizzard
